import React from "react";
import { NakiMobileHomeScreenTemplate } from "themes/administration/naki-mobile/pages";
import { NakiMobileHomeScreenViewStore } from "administration/naki-mobile/stores";
import { setCurrentView } from "mrb/core";
import { observer } from "mobx-react";

@setCurrentView(
    (rootStore, componentProps) => new NakiMobileHomeScreenViewStore(rootStore, componentProps),
    "nakiMobileHomeScreenViewStore"
)
@observer
class NakiMobileHomeScreen extends React.Component {
    render() {
        return <NakiMobileHomeScreenTemplate {...this.props} />;
    }
}

export default NakiMobileHomeScreen;
